import styled from 'styled-components';
export const ClosedOrCompledVoyagesWrapper = styled.div`
    opacity: 0.8;
`;

export const ChangeLogTree = styled.ul`
    max-height: calc(80vh - 100px);
    height: 100%;
    overflow-y: auto;

    .port-call-change-description {
        padding: 0 0 0 4px;
    }

    .berth-call-change-description {
        padding: 0 0 0 4px;
    }

    .tree-port-calls {
        padding: 0 0 0 10px;
        font-size: 0.8rem;
        li {
            list-style: none;
            padding: 2px 0;
        }
    }

    .tree-berth-calls {
        padding: 0 0 0 10px;
        font-size: 0.75rem;
        font-weight: normal;
    }

    .tree-cargo-operations {
        padding: 0 0 0 10px;
        font-size: 0.7rem;
        font-weight: normal;
    }

    .tree-cargo {
        padding: 0 0 0 10px;
        font-size: 0.7rem;
        font-weight: normal;
    }

    .dd-item {
        display: flex;
        flex-direction: column;
        margin: 0 0 20px 0;
        padding: 10px;
    }

    .closed-voyages-header {
        svg {
            cursor: pointer;
            float: right;
        }
    }
`;

export const ChangeLogLabel = styled.span`
    font-weight: bold;
`;

export const ChangeLogEntryWrapper = styled.div`
    display: flex;
    align-items: baseline;
    gap: 1rem;
`;

export const DescriptionText = styled.div`
    font-weight: 600;
    font-size: smaller;
    font-style: italic;
`;
